import { MouseEvent } from "react"

import { TextSmall } from "@finanedi.es/front/common/atoms"
import { ILeyAntiFraudeFormActionsProps } from "../../interfaces"

export const leyAntiFraudeFormActions = ({
  onClose,
  loading,
  isFormValid,
  errorMessage,
}: ILeyAntiFraudeFormActionsProps) => [
  {
    type: "template",
    template: (
      <TextSmall
        text={errorMessage}
        className='fs-text-danger'
      />
    ),
    hidden: !errorMessage,
  },
  {
    group: "buttons",
    groupClassName:
      "fs-flex fs-flex-col-reverse fs-gap-2 1k:fs-flex-row 1k:fs-justify-end",
    actions: [
      {
        label: "Cancelar",
        buttonType: "secondary",
        className: "fs-w-full fs-justify-center",
        wrapperClassName: "fs-w-full fs-text-sm",
        onClick: (e: MouseEvent<HTMLButtonElement>) => {
          e.preventDefault()
          onClose()
        },
      },
      {
        label: "Guardar",
        buttonType: "primary",
        className: "fs-w-full fs-justify-center",
        wrapperClassName: "fs-w-full fs-text-sm",
        loading,
        disabled: !isFormValid,
      },
    ],
  },
]
